import React, {useContext} from "react";

import clsx from "clsx";

import {WappContext, withWapp} from "wapplr-react/dist/common/Wapp";
//import getUtils from "wapplr-react/dist/common/Wapp/getUtils";

import {withMaterialStyles} from "../Template/withMaterial";

import MaterialAvatar from "@mui/material/Avatar";
import {useTheme} from "@mui/styles";

import materialStyle from "./materialStyle";
import style from "./style.css";

function Avatar(props) {

    const context = useContext(WappContext);
    //const utils = getUtils(context);
    const {subscribe, materialStyle, user, size = "list", color, ...rest} = props;

    const {wapp} = context;

    wapp.styles.use(style);

    const src = user?.thumb || "";
    const firstName = user?.name?.first || "User";
    const aLetter = firstName.slice(0,1);

    const materialTheme = useTheme();

    return (
        <div className={materialStyle.root}>
            <MaterialAvatar
                sx={{ bgcolor: (color === "secondary") ? materialTheme?.palette.secondary.main : materialTheme?.palette.text.primary }}
                alt={firstName}
                children={(!src) ? aLetter : null}
                className={clsx(
                    style.avatar,
                    materialStyle.avatar,
                    {[materialStyle.small]: (size === "small")},
                    {[style.small]: (size === "small")},
                    {[materialStyle.list]: (size === "list")},
                    {[style.list]: (size === "list")},
                    {[materialStyle.big]: (size === "big")},
                    {[style.big]: (size === "big")}
                )}
                {...(src) ? {src} : {}}
                {...rest}
            />
        </div>
    )
}

const WappComponent = withWapp(Avatar);

const StyledComponent = withMaterialStyles(materialStyle, WappComponent);

export default StyledComponent;
